import styled from "styled-components";
import colors from "../../constants/colors";

export const NoSlotsText = styled("div")<{ $highlight?: boolean }>(
  ({ $highlight }) => ({
    color: $highlight ? colors.RED : colors.GREY_6,
    fontSize: "0.6875rem",
    fontWeight: $highlight ? 600 : 400,
  }),
);

export const SlotsPreviewContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0.125rem",
  fontSize: "0.6875rem",
  color: colors.GREY_7,
  lineHeight: 1.3,
});
